import { useTheme } from "@emotion/react";
import { useMediaQuery } from "@mui/material";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { RootState } from "store";
import { footer_transaltion } from "transalations";
import { authenticated_routes, set_localize_content } from "utils/helper";
import {
  getDataFromLocalStorage,
  getStringFromLocalStorage,
} from "utils/localStore";
import facebook from "../../../assets/images/footer/facebook.webp";
import halal from "../../../assets/images/footer/halal.webp";
import instagram from "../../../assets/images/footer/instagram.webp";
import mail from "../../../assets/images/footer/mail.webp";
import phone_call_1 from "../../../assets/images/footer/phone_call_1.webp";
import pizza_oven from "../../../assets/images/footer/pizza_oven.webp";
import tiktok from "../../../assets/images/footer/tiktok.webp";
import time from "../../../assets/images/footer/time.webp";

export default function Footer() {
  const language = useSelector((state: RootState) => state.language.language);
  const location = useLocation();
  const token = getStringFromLocalStorage("token");
  const membership = getStringFromLocalStorage("membership");
  const store = getDataFromLocalStorage("store");
  const theme = useTheme() as any;
  const matchDownSm = useMediaQuery(theme.breakpoints.down("sm"));
  const matchDownMd = useMediaQuery(theme.breakpoints.down("md"));
  const smallscr = useMediaQuery(theme.breakpoints.down("lg"));

  if (matchDownSm) return null;

  return (
    <div
      className={"footer-main"}
      style={{
        marginTop:
          authenticated_routes.includes(location.pathname) ||
          // eslint-disable-next-line
          location.pathname.startsWith("/address-details") ||
          // eslint-disable-next-line
          (location.pathname.startsWith("/add-address") && matchDownMd)
            ? 0
            : (!token && !membership) || !store
            ? 0
            : 80,
      }}
    >
      <div
        className={"footer-inner padding-inline"}
        style={{ paddingInline: smallscr ? "30px" : "" }}
      >
        <div className={"footer-content"}>
          <div className="footer-list-container">
            <ul
              className="footer-list"
              style={{ paddingLeft: smallscr ? "10px" : "" }}
            >
              <li>
                <Link to="/about">
                  <span
                    className={
                      location.pathname === "/about" ? "active-link" : "span-li"
                    }
                  >
                    {set_localize_content(
                      footer_transaltion.about_dominos,
                      language
                    )}
                  </span>
                </Link>
              </li>
              <li>
                {/* <Link to={"/hygiene-certificate"}> */}
                <span
                  style={{ cursor: "default" }}
                  className={
                    location.pathname === "/hygiene-certificate"
                      ? "active-link"
                      : "span-li"
                  }
                >
                  {set_localize_content(
                    footer_transaltion.hygiene_certificate,
                    language
                  )}
                </span>
                {/* </Link> */}
              </li>
              <li>
                <Link to={"/join-our-team"}>
                  <span
                    className={
                      location.pathname === "/join-our-team"
                        ? "active-link"
                        : "span-li"
                    }
                  >
                    {set_localize_content(
                      footer_transaltion.join_our_team,
                      language
                    )}
                  </span>
                </Link>
              </li>
            </ul>
            <ul
              className="footer-list"
              style={{ paddingLeft: smallscr ? "10px" : "" }}
            >
              <li>
                <Link to={"terms-and-conditions"}>
                  <span
                    className={
                      location.pathname === "/terms-and-conditions"
                        ? "active-link"
                        : "span-li"
                    }
                  >
                    {set_localize_content(
                      footer_transaltion.terms_and_conditions,
                      language
                    )}
                  </span>
                </Link>
              </li>
              <li>
                <Link to={"/privacy-policy"}>
                  <span
                    className={
                      location.pathname === "/privacy-policy"
                        ? "active-link"
                        : "span-li"
                    }
                  >
                    {set_localize_content(
                      footer_transaltion.privacy_policy,
                      language
                    )}
                  </span>
                </Link>
              </li>
              <li>
                <Link to={"/delivery-policy"}>
                  <span
                    className={
                      location.pathname === "/delivery-policy"
                        ? "active-link"
                        : "span-li"
                    }
                  >
                    {set_localize_content(
                      footer_transaltion.delivery_policy,
                      language
                    )}
                  </span>
                </Link>
              </li>
              <li>
                <Link to={"/return-policy"}>
                  <span
                    className={
                      location.pathname === "/return-policy"
                        ? "active-link"
                        : "span-li"
                    }
                  >
                    {set_localize_content(
                      footer_transaltion.return_policy,
                      language
                    )}
                  </span>
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-icons-sec">
            <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
              <img
                src={halal}
                alt="Halal"
                width={smallscr ? 45 : 62}
                height={smallscr ? 45 : 62}
                loading="lazy"
              />
              <img
                src={time}
                alt="30-min"
                width={smallscr ? 82 : 104}
                height={smallscr ? 60 : 76}
                loading="lazy"
              />
              <img
                src={pizza_oven}
                alt="oven"
                width={smallscr ? 50 : 59}
                height={smallscr ? 49 : 58}
                loading="lazy"
              />
            </div>
            <p
              className="Kanit-Light text-blue"
              style={{ fontSize: smallscr ? 14 : "", textAlign: "center" }}
            >
              © {set_localize_content(footer_transaltion.copy_right, language)}{" "}
              {new Date().getFullYear()} |{" "}
              {set_localize_content(footer_transaltion.developed_by, language)}{" "}
              <a
                href="https://www.hitech-prime.com/"
                target="_blank"
                rel="noreferrer"
                className="text-blue hover-underline"
              >
                {" "}
                {set_localize_content(
                  footer_transaltion.hitech_prime,
                  language
                )}{" "}
              </a>
            </p>
          </div>

          <div className="footer-social-sec Kanit-SemiBold">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: matchDownMd ? "flex-end" : "flex-start",
                gap: 18,
              }}
            >
              <a
                href="https://www.facebook.com/dominosgeorgia"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={facebook}
                  alt="Facebook"
                  width={smallscr ? 35 : 43}
                  height={smallscr ? 35 : 43}
                  loading="lazy"
                />
              </a>
              <a
                href="https://www.instagram.com/dominos_geo"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={instagram}
                  alt="Instagram"
                  width={smallscr ? 35 : 43}
                  height={smallscr ? 35 : 43}
                  loading="lazy"
                />
              </a>
              <a href="https://www.tiktok.com/@dominos_georgia" target="_blank" rel="noreferrer">
                <img
                  src={tiktok}
                  alt="Tiktok"
                  width={smallscr ? 35 : 43}
                  height={smallscr ? 35 : 43}
                  loading="lazy"
                />
              </a>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: matchDownMd ? "flex-end" : "flex-start",
              }}
            >
              <div style={{ textAlign: matchDownMd ? "center" : "start" }}>
                <Link to={`tel:032 2 99 88 88`}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <div>
                      <img
                        src={phone_call_1}
                        alt="Phone"
                        width={smallscr ? 18 : 20}
                        height={smallscr ? 18 : 20}
                        loading="lazy"
                      />
                    </div>
                    <p style={{ fontSize: smallscr ? "14px" : "16px" }}>
                      032 2 99 88 88
                    </p>
                  </div>
                </Link>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <div>
                    <img
                      src={mail}
                      alt="Mail"
                      width={smallscr ? 18 : 20}
                      height={smallscr ? 18 : 20}
                      loading="lazy"
                    />
                  </div>
                  <p style={{ fontSize: smallscr ? "14px" : "16px" }}>
                    <a className="text-blue" href="mailto:info@dominospizza.ge">
                      {set_localize_content(footer_transaltion.info, language)}
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
